import { doPost, parseListPath } from "../request";
import { ListInvitationEmail } from "models/list-invitation-email";
import { List } from "models/list";

export const adminDoPostListInvitationEmail = async (
  list: List,
  invitationUuid: string,
  subject: string,
  message: string,
) => {
  const email = await doPost<ListInvitationEmail>(
    parseListPath(list, `invitation/${invitationUuid}/email`),
    { subject, message },
  );
  return email;
};
